/**
 * Display Config
 *
 * World-overlay display offsets — name-tags, NPC text, map name banner.
 * Tiny surface today; lives here so future visible-overlay tweaks land in
 * one obvious place rather than scattering as magic numbers.
 *
 * Two-section file (defaults+dev-override pattern). See
 * `docs/plans/2026-04-25-CONFIG-MIGRATION.md` for the canonical pattern.
 */

export interface DisplayConfig {
  /** Y position (px) of the map-name banner overlay. Positive = below screen top. */
  mapNameY: number;
  /** Pixel offset above an NPC sprite where its label/name renders. Negative = above. */
  npcTextOffsetY: number;
}

export const DISPLAY_DEFAULTS: DisplayConfig = {
  mapNameY: 20,
  npcTextOffsetY: -40,
};

/**
 * Per-dev-environment overrides. Partial — anything omitted falls through
 * to DISPLAY_DEFAULTS.
 */
export const DISPLAY_DEV_OVERRIDE: Partial<DisplayConfig> = {};

export const DISPLAY: DisplayConfig = {
  ...DISPLAY_DEFAULTS,
  ...DISPLAY_DEV_OVERRIDE,
};
